<template>
  <div>
    <div v-if="hasMore">
      <BrowseLoading :loading="isLoading" />

      <button
        v-if="$slots.retry && (!isLoading && hasError)"
        class="vs-btn btn btn--outline--pink-100 btn--hover--fill--pink-100"
        @click="retryFn"
      >
        <slot name="retry" />
      </button>
    </div>
    <button
      v-else-if="$slots.scrollEnd"
      class="vs-btn btn btn--outline--pink-100 btn--hover--fill--pink-100"
      @click="scrollToTop"
    >
      <slot name="scrollEnd" />
    </button>
  </div>
</template>

<script>
import BrowseLoading from './BrowseLoading';

export default {
  components: {
    BrowseLoading,
  },
  props: {
    hasMore: {
      type: Boolean,
      default: true,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    retryFn() {
      this.$emit('retry');
    },
  },
};
</script>

<style>
</style>
